import { render, staticRenderFns } from "./_bulk_my_sharing_modal.vue?vue&type=template&id=2511cda8&scoped=true&"
import script from "./_bulk_my_sharing_modal.vue?vue&type=script&lang=js&"
export * from "./_bulk_my_sharing_modal.vue?vue&type=script&lang=js&"
import style0 from "./_bulk_my_sharing_modal.vue?vue&type=style&index=0&id=2511cda8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2511cda8",
  null
  
)

export default component.exports